import { render } from "./Uppercase.vue?vue&type=template&id=b4e4f802&scoped=true"
import script from "./Uppercase.vue?vue&type=script&lang=js"
export * from "./Uppercase.vue?vue&type=script&lang=js"

import "./Uppercase.vue?vue&type=style&index=0&id=b4e4f802&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4e4f802"]])

export default __exports__